import axios from "axios";
import { takeLatest, call, put, select, takeEvery } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../utils/queryParams";

export const SET_UPDATES_LOADING = "saga/dailyPulse/SET_UPDATES_LOADING";

export const SET_DATES = "saga/SET_DATES";

export const UPDATE_DATES = "saga/dailyPulse/UPDATE_DATES";

export const FETCH_CURRENT_USER = "sagas/dailyPulse/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "sagas/dailyPulse/FETCH_CURRENT_USER_SUCCESS";

export const FETCH_SECTION_DATA_SUCCESS = "sagas/dailyPulse/FETCH_SECTION_DATA_SUCCESS";
export const FETCH_SECTION_DATA = "sagas/dailyPulse/FETCH_SECTION_DATA";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  fetchSectionData: createAction(FETCH_SECTION_DATA),
  updateDate: createAction(UPDATE_DATES)
};

export default function* watchDailyPulse() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUserData);
  yield takeEvery(FETCH_SECTION_DATA, fetchSectionData);
}

export function* getCommonApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  return yield select((state) => {
    const { date } = state.dailyPulse;

    return { organization_id, short_url, date };
  });
}

export function* fetchCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });

  yield put({ type: SET_DATES });
}

export function* fetchSectionData({ payload: { key, urn } }) {
  yield put({ type: SET_UPDATES_LOADING, payload: { key: key, isLoading: true } });

  const params = yield getCommonApiParams();

  let url = queryParams.apiVersion + "pages/daily_pulse/" + urn;
  try {
    let { data } = yield call(axios.get, url, { params });
    yield put({ type: FETCH_SECTION_DATA_SUCCESS, payload: { key: key, chartData: data } });
  } catch (err) {
    console.error(err);
  }
}
